import { ConciliacaoBancaria } from './../domain/conciliacao-bancaria.model';
import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';

export class ConciliacaoBancariaSerializer extends DomainSerializer<ConciliacaoBancaria> {}
